import { FunctionComponent, useEffect } from 'react';
import { Stack, FormControl, InputLabel, OutlinedInput, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import AccreditationsService from '../../../shared/services/accreditations/accreditations.service';
import { IPostAccreditation } from '../../../shared/services/accreditations/accreditations.model';

export const AccreditationDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  isEdit: boolean,
  accreditationId?: string,
  isSubmitting: boolean,
  onSubmit: (values: IPostAccreditation, resetForm: () => void, isEdit: boolean, accreditationId?: string) => void,
}> = ({
  open,
  closeHandler,
  isEdit,
  accreditationId,
  isSubmitting,
  onSubmit
}) => {
    //Service
    const accreditationService = new AccreditationsService()

    const accreditationSchema = Yup.object().shape({
      name: Yup.string().trim().required('Name is required'),
      detail: Yup.string().trim().nullable(),
    })
    const formik = useFormik<IPostAccreditation>({
      validationSchema: accreditationSchema,
      enableReinitialize: false,
      initialValues: {
        name: '',
        detail: '',
      },
      onSubmit: (values, { resetForm }) => {
        onSubmit(values, resetForm, isEdit, accreditationId)
      }
    })

    useEffect(() => {
      if (open && isEdit && accreditationId) {
        accreditationService.getOne(accreditationId)
          .then(response => {
            formik.setFieldValue('name', response.name)
            formik.setFieldValue('detail', response.detail)
          })
          .catch(() => { })
      }
    }, [open, isEdit, accreditationId])

    return (
      <DialogWrapper
        open={open}
        onClose={closeHandler}
        title={isEdit ? 'Edit Accreditation' : 'Add Accreditation'}
        cancelHandler={closeHandler}
        submitHandler={formik.submitForm}
        isSubmitting={isSubmitting}
        disableSaveButton={isSubmitting}
      >
        <Stack sx={{ mt: 1 }}>
          <FormControl fullWidth error={formik.touched.name && Boolean(formik.errors.name)}>
            <InputLabel htmlFor="name">Name</InputLabel>
            <OutlinedInput
              id="name"
              label="Name"
              value={formik.values.name || ''}
              onChange={(e) => formik.setFieldValue('name', e.target.value)}
            />
            <FormHelperText>
              {formik.touched.name && formik.errors.name ? formik.errors.name : ' '}
            </FormHelperText>
          </FormControl>
          <FormControl fullWidth error={formik.touched.detail && Boolean(formik.errors.detail)}>
            <InputLabel htmlFor="detail">Additional Information</InputLabel>
            <OutlinedInput
              id="detail"
              label="Additional Information"
              value={formik.values.detail || ''}
              onChange={(e) => formik.setFieldValue('detail', e.target.value)}
            />
            <FormHelperText>
              {formik.touched.detail && formik.errors.detail ? String(formik.errors.detail) : ' '}
            </FormHelperText>
          </FormControl>
        </Stack>
      </DialogWrapper>
    )
  }


